// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MegaMenuList-module__wrap--t0cGD","heading":"MegaMenuList-module__heading--253nu","list":"MegaMenuList-module__list--1lwmq","link":"MegaMenuList-module__link--3feCM"};